export enum eHoaDonTrangThai {
  NHAP = 1,
  DA_PHAT_HANH = 2,
  DA_HUY = 3,
  CHUA_CO_KET_QUA_PHAN_HOI = 4,
  DA_GUI_LEN_CQT_PHAN_HOI_KY_THUAT = 5,
  DA_GUI_LEN_CQT_CHUA_PHAN_HOI_KIEM_TRA_DU_LIEU = 6,
  KHONG_HOP_LE = 7,
  LOI_THONG_DIEP = 8,
  CHUA_GUI_CQT = 9,
  DA_GUI_CQT_CHUA_PHAN_HOI = 10,
}
